import React, { useState, useEffect } from "react";
import { Tabs, Tab, Row, Col, Card } from "react-bootstrap";
import {
    FaBuilding,
    FaBriefcase,
    FaTree,
    FaShip,
    FaCompass,
    FaCamera,
    FaPhone,
    FaEnvelope,
    FaMapMarkerAlt
} from "react-icons/fa";

import data from "../data/TourismRegisteredUnitsData.js";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Accordion } from "react-bootstrap";

const handleDownloadPDF = () => {
    const doc = new jsPDF();

    let startY = 20;
    let slNo = 1;

    const addCategoryTable = (title, list) => {
        doc.setFontSize(14);
        doc.text("Registered Tourism Service Providers", 105, 10, { align: "center" });
        doc.text(title, 14, startY);
        startY += 5;

        const tableData = list.map((item) => [
            slNo++,
            item.regNo,
            item.name,
            item.mobile,
            item.email,
            item.address
        ]);

        autoTable(doc, {
            startY,
            head: [["SL No", "Registration No", "Name", "Mobile", "Email", "Address"]],
            body: tableData,
            didDrawPage: function () {
                startY = 20;
            },
            styles: {
                fontSize: 8,
                cellPadding: 2,
                valign: "middle"
            },

            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 35 },
                2: { cellWidth: 30 },
                3: { cellWidth: 25 },
                4: { cellWidth: 45 },
                5: { cellWidth: "auto" }
            },

            headStyles: {
                fillColor: [200, 200, 200],
                textColor: 0
            },

            theme: "grid",
            margin: { left: 10, right: 10 }
        });

        startY = doc.lastAutoTable.finalY + 10;
    };

    addCategoryTable("Accommodation Unit", data.accommodation, "Accommodation");
    addCategoryTable("ASO", data.aso, "ASO");
    addCategoryTable("Boat", data.boat, "Boat");
    addCategoryTable("Tour Operator", data.tourOperators, "Tour Operator");
    addCategoryTable("Tourist Guide", data.guides, "Tourist Guide");
    addCategoryTable("Photographer", data.photographers, "Photographer");

    doc.save("Tourism_Registered_Units.pdf");
};

const RegisteredUnits = () => {
    const [activeTab, setActiveTab] = useState("accommodation");
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const renderCards = (list) => {
        if (!list.length) {
            return <p className="text-center">No data available</p>;
        }

        return (
            <Row className="g-4">
                {list.map((item, index) => (
                    <Col lg={4} md={6} sm={12} key={index}>
                        <Card
                            className="h-100 shadow-sm border-0"
                            style={{ transition: "0.2s ease" }}
                            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-4px)"}
                            onMouseLeave={e => e.currentTarget.style.transform = "translateY(0)"}
                        >
                            <Card.Body className="d-flex flex-column">


                                <Card.Title className="fw-bold mb-2 text-secondary" style={{ fontSize: '1.2rem' }} >
                                    {item.name}
                                </Card.Title>


                                <hr className="my-2" />

                                <div className="mb-2">
                                    <small className="text-muted">Registration No:</small>
                                    <div className="fw-semibold">{item.regNo}</div>
                                </div>

                                <div className="mb-2 d-flex align-items-center gap-2">
                                    <FaPhone size={13} className="text-danger" />
                                    <span>{item.mobile}</span>
                                </div>

                                <div className="mb-2 d-flex align-items-center gap-2">
                                    <FaEnvelope size={13} className="text-primary" />
                                    <span className="text-truncate">{item.email}</span>
                                </div>

                                <div className="mt-auto pt-2 border-top">
                                    <div className="d-flex align-items-start gap-2">
                                        <FaMapMarkerAlt size={13} className="text-success mt-1" />
                                        <small className="text-muted">{item.address}</small>
                                    </div>
                                </div>

                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        );
    };

    return (
        <div className="container my-4">
            <h3 className="mb-4 text-center display-6 display-md-5"
                style={{ fontFamily: '"EB Garamond", serif' }}>
                Registered Tourism Service Providers
            </h3>

            <div className="d-flex justify-content-end mb-3">
                <button className="btn btn-outline-primary" onClick={handleDownloadPDF}>
                    Download PDF
                </button>
            </div>

            <div>
                {isMobile ? (

                    <Accordion className="mb-4">

                        <Accordion.Item eventKey="0">
                            <Accordion.Header>
                                Accommodation ({data?.accommodation?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.accommodation || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                Tour Operators ({data?.tourOperators?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.tourOperators || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>
                                ASO ({data?.aso?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.aso || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>
                                Boat ({data?.boat?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.boat || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="4">
                            <Accordion.Header>
                                Tourist Guide ({data?.guides?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.guides || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="5">
                            <Accordion.Header>
                                Photographer ({data?.photographers?.length || 0})
                            </Accordion.Header>
                            <Accordion.Body>
                                {renderCards(data?.photographers || [])}
                            </Accordion.Body>
                        </Accordion.Item>

                    </Accordion>

                ) : (

                    <Tabs
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        id="registered-units-tabs"
                        className="mb-4"
                        justify
                    >

                        <Tab
                            eventKey="accommodation"
                            title={
                                <span className={`fw-semibold ${activeTab === "accommodation" ? "text-primary" : "text-dark"}`}>
                                    <FaBuilding className="me-1" />
                                    Accommodation ({data?.accommodation?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.accommodation || [])}
                        </Tab>

                        <Tab
                            eventKey="tourOperators"
                            title={
                                <span className={`fw-semibold ${activeTab === "tourOperators" ? "text-primary" : "text-dark"}`}>
                                    <FaBriefcase className="me-1" />
                                    Tour Operators ({data?.tourOperators?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.tourOperators || [])}
                        </Tab>

                        <Tab
                            eventKey="aso"
                            title={
                                <span className={`fw-semibold ${activeTab === "aso" ? "text-primary" : "text-dark"}`}>
                                    <FaTree className="me-1" />
                                    ASO ({data?.aso?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.aso || [])}
                        </Tab>

                        <Tab
                            eventKey="boat"
                            title={
                                <span className={`fw-semibold ${activeTab === "boat" ? "text-primary" : "text-dark"}`}>
                                    <FaShip className="me-1" />
                                    Boat ({data?.boat?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.boat || [])}
                        </Tab>

                        <Tab
                            eventKey="guides"
                            title={
                                <span className={`fw-semibold ${activeTab === "guides" ? "text-primary" : "text-dark"}`}>
                                    <FaCompass className="me-1" />
                                    Tourist Guide ({data?.guides?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.guides || [])}
                        </Tab>

                        <Tab
                            eventKey="photographers"
                            title={
                                <span className={`fw-semibold ${activeTab === "photographers" ? "text-primary" : "text-dark"}`}>
                                    <FaCamera className="me-1" />
                                    Photographer ({data?.photographers?.length || 0})
                                </span>
                            }
                        >
                            {renderCards(data?.photographers || [])}
                        </Tab>

                    </Tabs>

                )}
            </div>

        </div>
    );
};

export default RegisteredUnits;